import type React from 'react';

const ENTER_NAV_SELECTOR = '[data-enter-nav]';
const ENTER_FOCUS_SELECTOR = '[data-enter-focus]';

function focusableIn(container: Element): HTMLElement | null {
  return (
    container.querySelector<HTMLElement>(ENTER_FOCUS_SELECTOR) ??
    container.querySelector<HTMLElement>(
      'input, button, select, textarea, [tabindex]:not([tabindex="-1"])',
    )
  );
}

export function focusNextEnterNav(from: Element | null): void {
  if (!from || typeof document === 'undefined') return;
  const nodes = Array.from(document.querySelectorAll(ENTER_NAV_SELECTOR));
  const index = nodes.findIndex((node) => node === from || node.contains(from));
  if (index < 0) return;
  for (let i = index + 1; i < nodes.length; i += 1) {
    const next = focusableIn(nodes[i]);
    if (next && !next.hasAttribute('disabled')) {
      next.focus();
      return;
    }
  }
}

export function handleEnterNavKeyDown(
  event: React.KeyboardEvent<HTMLElement>,
): void {
  if (event.key !== 'Enter' || event.shiftKey || event.defaultPrevented) return;
  const target = event.currentTarget;
  const container = target.closest(ENTER_NAV_SELECTOR);
  if (!container) return;
  event.preventDefault();
  focusNextEnterNav(container);
}
